import { request } from "../../utils/request";

export const postLoginApi = (body: Login.PostLoginPayloadType) => {
  // 使用JSON格式传递登录参数
  const requestBody = {
    username: body.username,
    password: body.password,
    // 将前端「记住我」勾选状态透传给后端，未勾选时默认为 false
    rememberMe: body.rememberMe ?? false,
  };

  return request<Login.LoginResponse>("/system/auth/login", {
    method: "POST",
    body: requestBody,
    skipAuth: true, // 登录请求不需要认证头
  });
};

export const postRegisterApi = (body: Login.PostRegisterPayloadType) => {
  // 新的注册接口参数：只包含 username, mobile, password
  const requestBody = {
    username: body.username,
    mobile: body.phone || body.mobile, // 兼容 phone 和 mobile 字段
    password: body.password,
  };
  
  return request<Login.RegisterResponse>("/system/user/register", {
    method: "POST",
    body: requestBody,
    skipAuth: true,
  });
};
